import React, { useCallback, useRef, useState } from 'react';

import { ImageGalleryBlockData } from 'api/cms';
import Slideshow from 'components/Slideshow';
import { useElementReachedEffect } from 'utils/screen';

type Props = {
  data: ImageGalleryBlockData;
  blockIndex: number;
};

export function ImageGalleryBlock({ data: { images }, blockIndex }: Props) {
  const [show, setShow] = useState(blockIndex > 2);
  const lazyRef = useRef<HTMLDivElement>(null);

  useElementReachedEffect({
    ref: lazyRef,
    offset: { top: 200 },
    onReach: useCallback(() => setShow(true), []),
  });

  return show ? (
    <Slideshow items={images} data-qa-id="cms-image-gallery" round />
  ) : (
    <div ref={lazyRef} />
  );
}
